import ProjectRegisterMyGames from "@libs/project_register/ProjectRegisterMyGames";
import ThrowGTMEvent from "@model/helpers/ThrowGTMEvent";

import { createNamespacedHelpers } from "vuex";

const { mapState, mapGetters } = createNamespacedHelpers("global");

const ProjectRegisterMixin = {
  computed: Object.assign(
    {},
    mapGetters([
      "isUserInProject",
      "isUserNotAuthed",
      "isUserAuthedNotRegistered",
      "isShowProjectRegister",
    ]),
    mapState(["project_user"])
  ),
  components: {
    ProjectRegisterMyGames,
  },
  methods: {
    signIn() {
      this.$auth_service.showSignin();
    },
    signUp() {
      if (this.isUserAuthedNotRegistered) {
        this.$store.commit("global/writeIsShowProjectRegister", true);
        ThrowGTMEvent("ch.registration.init");
      } else {
        this.$auth_service.showSignup();
      }
    },
    logOut() {
      this.$auth_service.logout();
    },
    closeProjectRegister() {
      this.$store.commit("global/writeIsShowProjectRegister", false);
    },
    downloadGame() {
      this.$auth_service.downloadGame();
    },
  },
};
export default ProjectRegisterMixin;
